<div id="main-wrapper">

  <!-- Header
    ============================================= -->
  <app-header></app-header>
  <!-- Header end -->

  <!-- Page Header
      ============================================= -->
  <section class="page-header page-header-text-light bg-secondary mb-3">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-8">
          <h1>Reports at a Glance</h1>
        </div>
      </div>
    </div>
  </section><!-- Page Header end -->

  <!-- Content
    ============================================= -->
  <div id="content">
    <div class="container">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-4">
            <input type="text" class="form-control" placeholder="select Date" name="daterange" daterangepicker
              [options]="options" [value]="daterange.label" (selected)="selectedDate($event, daterange)">
          </div>
          <div class="col-sm-4">
            <select [(ngModel)]="reportType" class="form-control text-2">
              <option value="">Select Report Type</option>
              <option value="CruiseBookingReport">Cruise Booking Report</option>
            </select>
          </div>
          <div class="col-sm-4">
            <button (click)="search()" class="btn btn-primary mr-2">Search</button>
            <button (click)="exportToExcel()" class="btn btn-primary mr-2">Export</button>
          </div>
        </div>
      </div>
      <div class="text-center">
        <h5>{{this.reportname}}</h5>
      </div>
      <div class="bg-light shadow-md rounded p-4">
        <div id="LedgerStatement" class="table-responsive-md" *ngIf="reportname=='Ledger Statement Report'">
          <div class="col-sm-12">
            <div class="form-row">
              <div class="col-md-4 col-lg-4 form-group">
                <div class="autocomplete">
                  <input type="text" class="form-control" name="agentImport" (click)="makeItBlankimport($event)"
                    [(ngModel)]="agentImport" placeholder="Select Login Name" (keyup)="changeLoginNameimpprt($event)"
                    autocomplete="off">
                  <div id="autocomplete-list" class="autocomplete-items autocomplete-item text-left">
                    <div *ngFor="let RNames of ResagentImport;"
                      (click)="setLoginNameimport(RNames.ContactPerson,RNames.uid,RNames.sid)">
                      <strong>{{RNames.ContactPerson}}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-lg-3 form-group">
                <button (click)="Getagentwise()" class="btn btn-primary btn-block">Check for Agent</button>
              </div>
              <div class="col-md-2 col-lg-2 form-group">
                <button (click)="Reset()" class="btn btn-primary btn-block">Reset</button>
              </div>
            </div>
          </div>
          <table class="table table-hover border">
            <thead class="thead-light">
              <tr>
                <th>SNo.</th>
                <th>Txn Id</th>
                <th>Name</th>
                <th>PNR/Tkt</th>
                <th>Txn Date</th>
                <th class="text-right">Debit</th>
                <th class="text-right">Credit</th>
                <th class="text-right">Comm</th>
                <th class="text-right">TDS</th>
                <th class="text-right">Nett</th>
                <th class="text-right">Book Bal</th>
                <th class="text-right">A/c Bal</th>
                <th>Txn Type</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let booking of ledgerList;let i = index">
                <td class="text-right">{{i+1}}</td>
                <td class="align-left">{{booking.ReservationID}}</td>
                <td class="align-left">{{booking.Agency}}</td>
                <td class="align-left">
                  <span *ngFor="let PNR of booking.PNR.split('#')">{{PNR}}<br></span>
                </td>
                <td class="align-left">{{booking.TxnDate}}</td>
                <td class="text-right">{{booking.Debit | number}}</td>
                <td class="text-right">{{booking.Credit | number}}</td>
                <td class="text-right">{{booking.Comm | number}}</td>
                <td class="text-right">{{booking.TDS | number}}</td>
                <td class="text-right">{{booking.Nett | number}}</td>
                <td class="text-right">{{booking.Balance | number}}</td>
                <td class="text-right">{{booking.StatementBalance | number}}</td>
                <td>{{booking.TxnType}}</td>
                <td>{{booking.Remarks}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="statusreport" class="table-responsive-md" *ngIf="reportname=='Status Report'">
          <table class="table table-hover border w-auto">
            <thead class="thead-light">
              <tr>
                <th>SNo.</th>
                <th>Txn Id</th>
                <th>Booking Data</th>
                <th>ServerIP</th>
                <th class="text-right">TxnAmt</th>
                <th class="text-right">RcptAmt</th>
                <th>PG Name</th>
                <th>PaymentRef</th>
                <th>Channel</th>
                <th>PayStatus</th>
                <th>PNR</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let booking of statusList;let i = index">
                <td class="text-right">{{i+1}}</td>
                <td class="align-left">{{booking.TxnID}}</td>
                <td class="align-left">{{booking.SearchData}} <br /> {{booking.Pax}}</td>
                <td class="align-left">{{booking.ServerIP}}</td>
                <td class="text-right">{{booking.TxnAmt | number}}</td>
                <td class="text-right">{{booking.RcptAmt | number}}</td>
                <td class="align-left">{{booking.PGName}}</td>
                <td class="align-left">{{booking.Channel}}</td>
                <td class="align-left">{{booking.PaymentRef}}</td>
                <td class="align-left">{{booking.PayStatus}}</td>
                <td class="align-left">{{booking.PNR}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="CruiseBookingReport" class="table-responsive-md" *ngIf="reportname=='Cruise Booking Report'">
          <table class="table table-hover border">
            <thead class="thead-light">
              <tr>
                <th>SNo.</th>
                <th>Txn Id</th>
                <th>Pax Name</th>
                <th>Cruise</th>
                <th>Name/GSTN</th>
                <th>Deck / Cabin</th>
                <th>Hold / Max Hold</th>
                <th>PNR</th>
                <th>Pax Count</th>
                <th>DOJ</th>
                <th class="text-right">Gross / Part</th>
                <th>Voucher</th>
                <th class="text-right"></th>
            </tr>
            </thead>
            <tbody>
              <tr *ngFor="let booking of cruisebookingList;let i = index">
                <td class="text-right">{{i+1}}</td>
                <td class="align-left" *ngIf="booking.Status!='Pending' && booking.Status!='On Hold' && booking.Status!='Refunded' && booking.Status!='Cancelled'">
                    {{booking.ReservationID}}<br>{{booking.Description}}<br>{{booking.Status}}</td>
                <td class="align-left red" *ngIf="booking.Status=='Pending' || booking.Status=='On Hold' || booking.Status=='Cancelled'">
                    {{booking.ReservationID}}<br>{{booking.Description}}<br>{{booking.Status}}</td>
                <td class="align-left blue" *ngIf="booking.Status=='Refunded'">
                    <b>{{booking.ReservationID}}<br>{{booking.Description}}<br>{{booking.Status}}</b>
                </td>
                <td class="align-left">
                    <span *ngFor="let Pax of booking.Pax.split('/')">{{Pax}}<br></span>
                </td>
                <td class="align-left">{{booking.ShipName}}<br>{{booking.Nights}}<br>{{booking.Sailing}}</td>
                <td class="align-left">{{booking.AgencyName}}<br><b>{{booking.GSTN}}</b></td>
                <td class="align-left">{{booking.Deck}}<br />{{booking.Cabin}}</td>
                <td class="align-left">{{booking.HoldUpto}}<br />{{booking.HoldTxt}}</td>
                <td class="align-left">{{booking.PNR}} </td>
                <td class="align-left">{{booking.PaxCount}}</td>
                <td class="align-left">{{booking.DOJ}}<br />{{booking.SaleType}}</td>
                <td class="text-right">{{booking.TxnAmt}}<br />{{booking.partPayment}}</td>
                <td class="align-left">
                    <span *ngIf="booking.voucherLink != ''"><a class="red" href="{{booking.voucherLink}}" target="_blank">Download</a></span>
                </td>
                <td class="text-right red hand" (click)="showCruiseItinerary(booking,booking.ReservationID)">
                    <a class="fas fa-file-invoice" alt="" title="Itinerary"></a>
                </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Content end -->

    <!-- Footer
    ============================================= -->
    <app-footer></app-footer>
    <!-- Footer end -->

  </div>